import Vue from "vue";
import VueRouter from "vue-router";
import NewLogin from '@/views/newLogin';
import Home from '@/views/newLogin/main';
import About from '@/views/newLogin/main/about';
import Case from '@/views/newLogin/main/case';
import Feature from '@/views/newLogin/main/feature';
import Price from '@/views/newLogin/main/price';
import Contact from '@/views/newLogin/main/contact';

const routes = [
  {
    path: "/",
    name: "index",
    // component: () => import("@/views/index"),
    component: () => import("@/views/gptChat"),
    children: [],
  },
  {
    path: "/oldChat",
    name: "oldChat",
    component: () => import("@/views/index"),
    children: [],
  },
  // {
  //   path: "/chat",
  //   name: "chat",
  //   component: () => import("@/views/gptChat"),
  //   children: [],
  // },
  {
    path: "/newLogin",
    name: "newLogin",
    component: NewLogin,
    redirect: '/login',
    // component: () => import("@/views/newLogin"),
    children: [
      {
        path: '/login',
        name: 'login',
        // component: () => import('@/views/newLogin/main'),
        component: Home,
        meta: {
          title: '首页'
        }
      },
      {
        path: '/about',
        name: 'about',
        component: About,
        // component: () => import('@/views/newLogin/main/about'),
        meta: {
          title: '关于我们'
        }
      },
      {
        path: '/case',
        name: 'case',
        component: Case,
        // component: () => import('@/views/newLogin/main/case'),
        meta: {
          title: '案例'
        }
      },
      {
        path: '/feature',
        name: 'feature',
        component: Feature,
        // component: () => import('@/views/newLogin/main/feature'),
        meta: {
          title: '特色'
        }
      },
      {
        path: '/price',
        name: 'price',
        component: Price,
        // component: () => import('@/views/newLogin/main/price'),
        meta: {
          title: '价格'
        }
      },
      {
        path: '/contact',
        name: 'contact',
        component: Contact,
        // component: () => import('@/views/newLogin/main/contact'),
        meta: {
          title: '联系我们'
        }
      },
    ],
  },
  // {
  //   path: "/oldLogin",
  //   name: "login",
  //   component: () => import("@/views/login/login"),
  // },
  {
    path: "/authCallback",
    name: "authCallback",
    component: () => import("@/views/user/authCallback"),
  },
  {
    path: "/agent",
    name: "agent",
    component: () => import("@/views/info/agent"),
  },
  {
    path: "/agentMobile",
    name: "agentMobile",
    component: () => import("@/views/info/agentMobile"),
  },
];

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

// 前置守卫
router.beforeEach((to, from, next) => {
  // 使用 router.resolve() 检查即将访问的路由是否存在
  const resolved = router.resolve(to.path);
  if (resolved.resolved.matched.length > 0) {
    // 路由存在，继续导航
    next();
  } else {
    //debugger;
    // 路由不存在，跳转到指定页面
    next("/"); // 这里将 '/not-found' 替换为你要跳转的路径
  }
});

export default router;
